import React, {useEffect, useState} from "react";
import styles from './device_modal.module.css';
import {Modal as BootStrapModal} from "react-bootstrap";
import {PrimaryButton, RadioInput, SecondaryButton, TextInput} from "../input/inputs";
import axiosInstance from "../../AxiosInstance";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMapPin, faMobile, faTag} from "@fortawesome/free-solid-svg-icons";
import GoogleMapReact from "google-map-react";
import {QrReader} from 'react-qr-reader';
import inputStyles from '../input/inputs.module.css';
import VerticalInput from "../vertical_input/vertical_input";
import {Label, Select} from "../ajonjolib/inputs/ajonjolinput";
import LimitExceededModal from "../limit_exceeded_modal/LimitExceededModal";
import {useTranslation} from "react-i18next";

function DeviceModalSteps({form, setForm, step, setStep, deviceType, withMachine, variables}) {
    const {t} = useTranslation();
    const [addressInput, setAddressInput] = useState('');
    const [machineOptions, setMachineOptions] = useState([]);
    const [qrResult, setQrResult] = useState('None');
    const [deviceTypes, setDeviceTypes] = useState([]);
    const [center, setCenter] = useState({lat: 14.7273, lng: -17.4580});
    const [tagsInput, setTagsInput] = useState('');
    const handlePinClick = ({ lat, lng }) => {
        setForm({
            ...form,
            ["lat"]: lat,
            ["lng"]: lng
        })
    };

    const mapOptions = {
        center: {
            lat: 14.7273,
            lng: -17.4580
        },
        zoom: 16
    };

    useEffect(() => {
        const project_id = localStorage.getItem('project_id');

        axiosInstance.get(`machine/?project_id=${project_id}`).then((response) => {
            setMachineOptions(response.data);
        });

        axiosInstance.get('device_type/').then((response) => {
            setDeviceTypes(response.data.results);
        });
    }, []);

    const handleMovePin = async () => {
        try {
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(addressInput)}&key=AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g`
            );
            const data = await response.json();

            if (data.results.length > 0) {
                const { lat, lng } = data.results[0].geometry.location;
                setCenter({lat: lat, lng: lng});
                setForm({
                    ...form,
                    "lat": lat,
                    "lng": lng
                }); // Update the pin's coordinates
            } else {
                console.log('Address not found');
            }
        } catch (error) {
            console.error('Error fetching geocoding data', error);
        }
    };

    useEffect(() => {
        if(step === 2) {
            const machine = machineOptions.find((m) => m.id === parseInt(form['device_user_id']));
            const deviceUserFromStorage = JSON.parse(localStorage.getItem('device_user'));
            const asset = (!machine && deviceUserFromStorage?.id === parseInt(form['device_user_id']))
                ? deviceUserFromStorage
                : null;
            const deviceUser = machine || asset;
            const deviceType = deviceTypes.find((dt) => dt.id === form['type']);

            if (deviceUser?.name && deviceType?.name) {
                setForm({ ...form, 'name': `${deviceUser.name} ${deviceType.name}` });
            } else if (deviceType?.name) {
                setForm({ ...form, 'name': deviceType.name });
            }
        }
    }, [step])

    return (
        <div>
            {step === 1 &&
                <div>
                    <RadioInput name={'insertType'} internalName={'insertType'} hideName={true} options={[t('devices.deviceModal.scanQR'), t('devices.deviceModal.insertCode')]} form={form} setForm={setForm}/>
                    {form["insertType"] === 0 ?
                        <div>
                            <QrReader
                                onResult={(result, error) => {
                                    if (!!result) {
                                        setQrResult(result?.text);
                                        const splitStr = result?.text.split(';');
                                        setForm({
                                            ...form,
                                            'device_eui': splitStr[0],
                                            'app_key': splitStr[1],
                                            'app_eui': splitStr[2],
                                            'type': parseInt(splitStr[3])
                                        });
                                    }
                                }}
                                constraints={{facingMode: 'user'}}
                            />
                        </div>
                        :
                        <div>
                            <TextInput name={t('devices.deviceModal.deviceEUI')} internalName={'device_eui'} form={form} setForm={setForm}/>
                        </div>
                    }
                    <div className={'mb-3'}>
                        <Label>{t('devices.deviceModal.deviceType')}</Label>
                        <Select onChange={(value) => setForm({...form, type: value?.[0]})} value={form['type'] != null ? [form['type']] : null} options={deviceTypes.map((x) => {return {name: x.name, value: x.id}})}/>
                    </div>
                    {withMachine &&
                        <div className={'mb-3'}>
                            <Label>{t('devices.deviceModal.machine')}</Label>
                            <Select onChange={(value) => setForm({...form, device_user_id: value?.[0]})} value={form.device_user_id != null ? [form.device_user_id] : null} options={machineOptions.map((x) => {return {name: x.name, value: x.id}})}/>
                        </div>
                    }
                </div>
            }
            {step === 2 &&
                <div>
                    <TextInput name={t('devices.deviceModal.deviceName')} internalName={'name'} placeholder={t('devices.deviceModal.deviceNamePlaceholder')} form={form} setForm={setForm}/>
                    {deviceType?.has_gps ? (
                        <div className={'mb-3'}>
                            <div className={`mb-1`} style={{color: "#4B5563"}}>{t('devices.deviceModal.deviceLocation')}</div>
                            <div style={{fontSize: '13px', color: '#94A3B8', fontStyle: 'italic'}}>
                                {t('devices.deviceModal.gpsAutoLocation')}
                            </div>
                        </div>
                    ) : (
                        <div className={'mb-3'} onClick={() => {setStep(2.5)}}>
                            <div className={`mb-1`} style={{color: "#4B5563"}}>{t('devices.deviceModal.deviceLocation')}</div>
                            <div className={styles.locateButton}>
                                <FontAwesomeIcon icon={faMapPin} className={'pt-1 pe-1'} color={'#F00'}/>
                                <div>{t('devices.deviceModal.locate')}</div>
                            </div>
                        </div>
                    )}
                    <div className={'d-flex flex-wrap'}>
                        {form.tags?.split(' ').filter(tag => tag && tag !== 'undefined').map((tag, index) => (
                            <div key={index} className={styles.tag} role={'button'} onClick={() => {
                                const newTags = form.tags.split(' ').filter(t => t && t !== 'undefined' && t !== tag).join(' ');
                                setForm({
                                    ...form,
                                    tags: newTags,
                                });
                            }}>
                                <div>{tag}</div>
                                <div className={'ms-2 d-flex flex-column align-items-center align-content-center justify-content-center'} style={{
                                    backgroundColor: '#a2a2a2',
                                    borderRadius: '50%',
                                    padding: '0 7px'
                                }}>x</div>
                            </div>
                        ))}
                    </div>
                    <div className="form-group mb-3">
                        <div className={`${inputStyles.inputLabel} mb-1`}>{t('devices.deviceModal.deviceTags')}</div>
                        <input
                            type={'text'}
                            className={`${inputStyles.inputBorderDefault} form-control rounded-2`}
                            id={'device_tags'}
                            placeholder={t('devices.deviceModal.tagsPlaceholder')}
                            value={tagsInput}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    const value = tagsInput.trim();
                                    if (value) {
                                        const currentTags = form.tags || '';
                                        setForm({
                                            ...form,
                                            tags: currentTags ? currentTags + ' ' + value : value,
                                        });
                                        setTagsInput('');
                                    }
                                }
                            }}
                            onChange={(event) => {
                                const { value } = event.target;
                                if (value.endsWith(' ')) {
                                    const trimmedValue = value.trim();
                                    if (trimmedValue) {
                                        const currentTags = form.tags || '';
                                        setForm({
                                            ...form,
                                            tags: currentTags ? currentTags + ' ' + trimmedValue : trimmedValue,
                                        });
                                    }
                                    setTagsInput('');
                                } else {
                                    setTagsInput(value);
                                }
                            }}
                        />
                    </div>
                    {/* <TextInput name={t('devices.deviceModal.appKey')} internalName={'app_key'} form={form} setForm={setForm}/> */}
                    {/* <TextInput name={t('devices.deviceModal.appEUI')} internalName={'app_eui'} form={form} setForm={setForm}/> */}
                </div>
            }
            {step === 2.5 &&
                <div style={{height: "300px"}} className={'mb-5'}>
                    <div style={{ display: 'flex', alignItems: 'center'}} className={'mb-1'}>
                        <input
                            type="text"
                            placeholder={t('devices.deviceModal.enterAddress')}
                            value={addressInput}
                            onChange={(event) => setAddressInput(event.target.value)}
                            style={{ padding: '5px', marginRight: '10px', flex: 1 }}
                        />
                        <button onClick={handleMovePin} style={{ padding: '5px 10px', backgroundColor: '#007bff', color: '#fff', border: 'none', cursor: 'pointer' }}>
                            {t('devices.deviceModal.movePin')}
                        </button>
                    </div>

                    <GoogleMapReact
                        onClick={handlePinClick}
                        defaultCenter={mapOptions.center}
                        defaultZoom={mapOptions.zoom}
                        bootstrapURLKeys={{ key: 'AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g'}}
                        center={center}
                        onChange={(event) => setCenter(event.center)}
                        yesIWantToUseGoogleMapApiInternals
                    >
                        <div
                            lat={form.lat}
                            lng={form.lng}
                            style={{ width: '20px', height: '20px'}}
                            className={'d-flex justify-content-center align-items-center'}
                        >
                            <FontAwesomeIcon icon={faMapPin} color={'#F00'} size={'xl'}/>
                        </div>
                    </GoogleMapReact>
                </div>
            }
            {step === 3 && !deviceType.is_predictive_maintenance && variables && variables.length > 0 &&
                <div>
                    <RadioInput name={'varConfig'} hideName={true} options={[t('devices.deviceModal.dontConfigure'), t('devices.deviceModal.configure')]} form={form} setForm={setForm}/>
                </div>
            }
            {step === 4 &&
                <div className={styles.summary}>
                    <div>
                        <div>
                            <FontAwesomeIcon icon={faMobile}/>
                        </div>
                        <div className={'ps-3'}>
                            <div>{t('devices.deviceModal.deviceNameLabel')}</div>
                            <span>{form.name}</span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <FontAwesomeIcon icon={faMobile}/>
                        </div>
                        <div className={'ps-3'}>
                            <div>{t('devices.deviceModal.typeLabel')}</div>
                            <span>{deviceType.name}</span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <FontAwesomeIcon icon={faTag}/>
                        </div>
                        <div className={'ps-3'}>
                            <div>{t('devices.deviceModal.tagsLabel')}</div>
                            <div className={'d-flex flex-wrap'}>
                                {form.tags?.split(' ').filter(tag => tag && tag !== 'undefined').map((tag, index) => (
                                    <div key={index} className={styles.tag}>
                                        {tag}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

function DeviceModalVariables({variables, setVariables, setStep, form, setForm, callChildFunc, setSettingVariables, setCallChildFunc}) {
    const {t} = useTranslation();
    const [prevVal, setPrevVal] = useState(0);
    const [currentVariable, setCurrentVariable] = useState(0);
    const [alertForm, setAlertForm] = useState({
        green_1: 0,
        green_2: 0,
        yellow_1: 0,
        yellow_2: 0
    });
    const [savedVars, setSavedVars] = useState({});

    useEffect(() => {
        if(prevVal === callChildFunc) {
            if(savedVars[callChildFunc] !== undefined) {
                setAlertForm(savedVars[callChildFunc]);
            }
            setCurrentVariable(callChildFunc);
            setPrevVal(callChildFunc - 1);
            return;
        }

        if(callChildFunc === 0) {
            return;
        }

        let vars = variables;
        let jetztVar = vars[currentVariable];
        jetztVar.green_1 = alertForm.green_1;
        jetztVar.green_2 = alertForm.green_2;
        jetztVar.yellow_1 = alertForm.yellow_1;
        jetztVar.yellow_2 = alertForm.yellow_2;
        setSavedVars({
            ...savedVars,
            [currentVariable]: jetztVar
        });
        vars[currentVariable] = jetztVar;
        setVariables(vars);

        if(savedVars[callChildFunc] !== undefined) {
            setAlertForm(savedVars[callChildFunc]);
        }
        else {
            setAlertForm({
                green_1: 0,
                green_2: 0,
                yellow_1: 0,
                yellow_2: 0
            });
        }

        if(currentVariable + 1 === variables.length) {
            setStep((prev) => parseInt(prev) + 1);
            setSettingVariables(false);
            setCurrentVariable(0);
            setCallChildFunc(0);
            setForm({
                ...form,
                ["alerts"]: vars
            })
            return;
        }
        setPrevVal(callChildFunc - 1);
        setCurrentVariable(callChildFunc);
    }, [callChildFunc])

    const currentVar = variables[currentVariable];
    const dataType = currentVar?.data_type;
    const isBoolean = dataType === 'boolean';
    const isString = dataType === 'string';

    return (
        <div style={{color: "#334155", paddingBottom: '24px'}}>
            <div className={'d-flex'} style={{fontWeight: "600", fontSize: "20px"}}>
                <div>{currentVar.name}</div>
                <div className={'ps-2'}>{currentVariable + 1}/{variables.length}</div>
            </div>

            <div className={''}>
                {isString ? (
                    <div style={{padding: '16px', backgroundColor: '#f0f9ff', borderRadius: '8px', marginTop: '12px'}}>
                        <div style={{color: '#0369a1', fontWeight: 500}}>
                            {t('devices.deviceModal.stringVarDesc')}
                        </div>
                    </div>
                ) : isBoolean ? (
                    <div style={{marginTop: '12px'}}>
                        <div style={{fontWeight: "600", marginBottom: '12px'}}>{t('devices.deviceModal.boolAlertConfig')}</div>
                        <div style={{marginBottom: '8px', color: '#64748b'}}>{t('devices.deviceModal.boolAlertSelect')}</div>
                        <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '16px'}}>
                            {[
                                {val: true, label: t('devices.deviceModal.trueAlert')},
                                {val: false, label: t('devices.deviceModal.falseAlert')},
                                {val: null, label: t('devices.deviceModal.noAlert')},
                            ].map(opt => (
                                <label key={String(opt.val)} style={{
                                    display: 'flex', alignItems: 'center',
                                    padding: '8px 16px', borderRadius: '8px', cursor: 'pointer',
                                    border: alertForm.bool_alert_value === opt.val ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                                    backgroundColor: alertForm.bool_alert_value === opt.val ? '#eff6ff' : '#fff',
                                }}>
                                    <input
                                        type="radio"
                                        name="bool_alert_value"
                                        checked={alertForm.bool_alert_value === opt.val}
                                        onChange={() => setAlertForm({...alertForm, bool_alert_value: opt.val, bool_alert_type: opt.val !== null ? (alertForm.bool_alert_type || 1) : null})}
                                        style={{marginRight: '8px'}}
                                    />
                                    {opt.label}
                                </label>
                            ))}
                        </div>
                        {alertForm.bool_alert_value !== null && alertForm.bool_alert_value !== undefined && (
                            <>
                                <div style={{marginBottom: '8px', color: '#64748b'}}>{t('devices.deviceModal.alertType')}</div>
                                <div style={{display: 'flex', gap: '10px'}}>
                                    {[
                                        {v: 1, label: t('devices.deviceModal.danger'), color: '#ef4444', bg: '#fef2f2'},
                                        {v: 2, label: t('devices.deviceModal.warning'), color: '#f59e0b', bg: '#fffbeb'},
                                    ].map(opt => (
                                        <label key={opt.v} style={{
                                            display: 'flex', alignItems: 'center',
                                            padding: '8px 16px', borderRadius: '8px', cursor: 'pointer',
                                            border: Number(alertForm.bool_alert_type) === opt.v ? `2px solid ${opt.color}` : '1px solid #e2e8f0',
                                            backgroundColor: Number(alertForm.bool_alert_type) === opt.v ? opt.bg : '#fff',
                                        }}>
                                            <input
                                                type="radio"
                                                name="bool_alert_type"
                                                checked={Number(alertForm.bool_alert_type) === opt.v}
                                                onChange={() => setAlertForm({...alertForm, bool_alert_type: opt.v})}
                                                style={{marginRight: '8px'}}
                                            />
                                            <span style={{color: opt.color, fontWeight: 600}}>{opt.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                ) : (
                    <>
                        <div style={{fontWeight: "600"}}>{t('devices.deviceModal.alertRange')}</div>
                        <div className={'w-100 my-2'}>
                            <VerticalInput form={alertForm} setForm={setAlertForm}/>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default function DeviceModal({show, setter, withMachine}) {
    const {t} = useTranslation();
    const project_id = localStorage.getItem('project_id');
    const device_user_id = localStorage.getItem('device_user_id');
    const [step, setStep] = useState(1);
    const [settingVariables, setSettingVariables] = useState(false);
    const [form, setForm] = useState({project_id: project_id, device_user_id: device_user_id, insertType: 0});
    const [callChildFunc, setCallChildFunc] = useState(0);
    const [deviceType, setDeviceType] = useState({});
    const [variables, setVariables] = useState([]);

    // Limit exceeded modal state
    const [showLimitModal, setShowLimitModal] = useState(false);
    const [limitError, setLimitError] = useState({error: '', current: 0, max: 0, code: '', subscriptionStatus: null});
    const [euiError, setEuiError] = useState('');

    const titles = ["", t('devices.deviceModal.scanTitle'), t('devices.deviceModal.detailsTitle'), t('devices.deviceModal.variablesTitle'), t('devices.deviceModal.summaryTitle')];
    const descs = ["", t('devices.deviceModal.scanDesc'), t('devices.deviceModal.detailsDesc'), "", t('devices.deviceModal.summaryDesc')];

    const resetModal = () => {
        setter(false);
        setStep(1);
        setForm({project_id: project_id, device_user_id: device_user_id, insertType: 0});
        setSettingVariables(false);
        setCallChildFunc(0);
        setEuiError('');
    }

    const cancel = () => resetModal();

    const create = () => {
        setEuiError('');
        axiosInstance.post('create_device/', form).then(() => {
            window.location.reload();
        }).catch((err) => {
            if (err.response?.status === 402) {
                const data = err.response.data;
                setLimitError({
                    error: data.error || t('devices.deviceModal.deviceLimitError'),
                    current: data.current || 0,
                    max: data.max || 0,
                    code: data.code || '',
                    subscriptionStatus: data.status || null
                });
                setShowLimitModal(true);
                resetModal();
                return;
            }
            if (err.response?.status === 400) {
                setEuiError(err.response.data?.error || t('devices.deviceModal.euiError'));
                return;
            }
            console.error('Error creating device:', err);
        });
    }

    const nextStep = () => {
        if (step < 4){
            // Check if insertType is set
            if(step === 1) {
                if(!('insertType' in form)) return;
                axiosInstance.get('device_type/' + form.type + '/').then((response) => {
                    setDeviceType(response.data);
                    setVariables(response.data.variables);
                });
            }

            // Skip step 3 if predictive maintenance or no variables
            if(step === 2 && (deviceType.is_predictive_maintenance || !variables || variables.length === 0)) {
                setStep(4); // Skip to summary
                return;
            }

            // Check Variable Config
            if(step === 3) {
                if(!("varConfig" in form)) return;
                if(form.varConfig === 1) {
                    if(settingVariables === true) {
                        setCallChildFunc((prev) => parseInt(prev) + 1);
                    }
                    setSettingVariables(true);
                    return;
                }
            }

            setStep((prev) => parseInt(prev) + 1);
        } else {
            create()
        }

    }

    const prevStep = () => {
        if(step === 3) {
            if(!("varConfig" in form)) {
                setStep(2);
                return;
            }
            if(form.varConfig === 1) {
                if(settingVariables === true) {
                    if(callChildFunc === 0) {
                        setSettingVariables(false);
                    } else {
                        setCallChildFunc((prev) => parseInt(prev) - 1);
                    }
                } else {
                    setStep(2);
                }
            } else {
                setStep(2);
            }
            return;
        }
        if(step === 2.5) {
            setStep(2);
            return;
        }
        // Skip step 3 going back if it was skipped going forward
        if(step === 4 && (deviceType.is_predictive_maintenance || !variables || variables.length === 0)) {
            setEuiError('');
            setStep(2);
            return;
        }
        setEuiError('');
        setStep((prev) => prev - 1);
    }

    return (
        <>
        <LimitExceededModal
            show={showLimitModal}
            setter={setShowLimitModal}
            error={limitError.error}
            current={limitError.current}
            max={limitError.max}
            type="devices"
            code={limitError.code}
            subscriptionStatus={limitError.subscriptionStatus}
        />
        <BootStrapModal show={show} className={styles.container} centered={true}>
            <div className={styles.header}>
                <div className={'mb-1'}>
                    <div className={`${styles.progressBar} mb-2`}>
                        <div className={`${styles.bar} ${step >= 1 && styles.completedBar}`}/>
                        <div className={`${styles.bar} ${step >= 2 && styles.completedBar}`}/>
                        <div className={`${styles.bar} ${step >= 3 && styles.completedBar}`}/>
                        <div className={`${styles.bar} ${step >= 4 && styles.completedBar}`}/>
                    </div>
                    <div>{t('devices.deviceModal.step', {step: Math.floor(step)})}</div>
                </div>
                <div className={styles.title}>{titles[step]}</div>
                <div>{descs[step]}</div>
            </div>

            <div className={styles.body}>
                {step === 4 && euiError && (
                    <div style={{
                        padding: '10px 12px',
                        marginBottom: '12px',
                        borderRadius: '6px',
                        backgroundColor: '#FEF2F2',
                        border: '1px solid #FECACA',
                        color: '#DC2626',
                        fontSize: '13px',
                    }}>
                        {euiError}
                    </div>
                )}
                {settingVariables ?
                    <DeviceModalVariables variables={variables} setVariables={setVariables} callChildFunc={callChildFunc} form={form} setCallChildFunc={setCallChildFunc} setForm={setForm} setStep={setStep} setSettingVariables={setSettingVariables}/>
                    :
                    <DeviceModalSteps step={step} setStep={setStep} form={form} setForm={setForm} deviceType={deviceType} withMachine={withMachine} variables={variables}/>
                }

            </div>

            <div className={styles.footer}>
                <SecondaryButton onClick={() => cancel()} name={t('common.cancel')}/>
                {(step > 1) &&
                <div className={'ms-3'}>
                    <SecondaryButton onClick={() => {
                        prevStep();
                    }} name={t('common.back')}/>
                </div>
                }
                <div className={'ms-3'}>
                    {(step !== 2.5) ?
                        <PrimaryButton name={step < 4 ? t('common.continue') : t('devices.deviceModal.finish')} onClick={() => nextStep()}/>
                        :
                        <PrimaryButton name={t('common.continue')} onClick={() => prevStep()}/>
                    }
                </div>
            </div>
        </BootStrapModal>
        </>
    );
}